import Vue from 'vue';
import './plugins/vuetify';
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import fr from 'vee-validate/dist/locale/fr';
import VeeValidate, { Validator } from 'vee-validate';
import "./stylus/main.styl";
import VueAnalytics from 'vue-analytics';



import App from './App.vue';
import router from './router';
import store from './store';


Vue.config.productionTip = false;

Vue.use(wysiwyg, {
  hideModules: {
      "headings": true,
      "link": true,
      "code": true,
      "image": true,
      "table": true,
      "removeFormat": true,
      "separator": true,
      "orderedList": true,
      // "unorderedList": true,
  },
});

// https://codesandbox.io/s/9v81xk7yw
// https://vuetifyjs.com/en/components/forms
Validator.localize('fr', fr);
Vue.use(VeeValidate, {
  locale:'fr',
});

// google analytic
// https://medium.com/dailyjs/tips-tricks-for-vue-analytics-87a9d2838915
const isProd = process.env.NODE_ENV === 'production';
console.log('------- production? : ' + isProd);

Vue.use(VueAnalytics, {
  id: 'UA-142142691-1',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd,
  }
});
  


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
